import styled from 'styled-components';

export const Container = styled.div`
	max-width: 1100px;
	margin: 0 auto;
	padding: 24px 16px 48px;
`;

export const HeaderRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	flex-wrap: wrap;
	gap: 12px;
	margin-bottom: 24px;
`;

export const Title = styled.h1`
	margin: 0;
	font-size: 1.8rem;
	color: #2c3e50;
`;

export const Subtitle = styled.p`
	margin: 4px 0 0;
	color: #666;
	font-size: 0.95rem;
`;

export const BackButton = styled.button`
	padding: 8px 16px;
	border-radius: 6px;
	border: 1px solid #ddd;
	background: white;
	color: #555;
	cursor: pointer;
	font-size: 0.9rem;
	&:hover { background: #f8f9fa; }
`;

export const SummaryGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
	gap: 16px;
	margin-bottom: 28px;
`;

export const SummaryCard = styled.div`
	background: white;
	border: 1px solid #e9ecef;
	border-radius: 12px;
	padding: 18px;
	text-align: center;
	box-shadow: 0 2px 6px rgba(0,0,0,0.04);
`;

export const SummaryLabel = styled.div`
	font-size: 0.85rem;
	color: #888;
	margin-bottom: 6px;
`;

export const SummaryValue = styled.div`
	font-size: 2rem;
	font-weight: 700;
	color: #2c3e50;
`;

export const SummarySub = styled.div`
	font-size: 0.8rem;
	color: #aaa;
	margin-top: 2px;
`;

export const AlbumList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 14px;
`;

export const AlbumCard = styled.div`
	background: white;
	border: 1px solid #e9ecef;
	border-radius: 12px;
	padding: 18px;
	box-shadow: 0 2px 6px rgba(0,0,0,0.04);
`;

export const AlbumTop = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px;
	margin-bottom: 10px;
`;

export const AlbumName = styled.h3`
	margin: 0;
	font-size: 1.2rem;
	color: #2c3e50;
`;

export const UnitatBadge = styled.span`
	background: #ecf0f1;
	color: #2c3e50;
	border-radius: 12px;
	padding: 3px 12px;
	font-size: 0.78rem;
	font-weight: 600;
	text-transform: capitalize;
`;

export const Meta = styled.div`
	color: #888;
	font-size: 0.85rem;
	display: flex;
	gap: 14px;
	flex-wrap: wrap;
	margin-bottom: 12px;
`;

export const YearRow = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 6px;
`;

export const YearLabel = styled.span`
	min-width: 92px;
	font-variant-numeric: tabular-nums;
	color: #2c3e50;
	font-weight: 600;
`;

export const BarTrack = styled.div`
	flex: 1;
	height: 18px;
	background: #f0f0f0;
	border-radius: 9px;
	overflow: hidden;
`;

export const BarFill = styled.div<{ $width: number }>`
	height: 100%;
	width: ${({ $width }) => $width}%;
	background: #3498db;
	border-radius: 9px;
	transition: width 0.3s ease;
`;

export const YearCount = styled.span`
	min-width: 70px;
	font-size: 0.82rem;
	color: #888;
`;

export const ApplyRow = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	margin-top: 14px;
	flex-wrap: wrap;
`;

export const YearSelect = styled.select`
	padding: 8px 12px;
	border: 1px solid #ddd;
	border-radius: 6px;
	font-size: 0.9rem;
	background: white;
`;

export const ApplyButton = styled.button<{ $done?: boolean }>`
	padding: 8px 18px;
	border-radius: 6px;
	border: none;
	font-weight: 600;
	cursor: pointer;
	font-size: 0.9rem;
	color: white;
	background: ${({ $done }) => ($done ? '#27ae60' : '#2c3e50')};
	&:hover { background: ${({ $done }) => ($done ? '#219a52' : '#1a252f')}; }
	&:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export const ViewLink = styled.button`
	padding: 8px 14px;
	border-radius: 6px;
	border: 1px solid #ddd;
	background: white;
	color: #555;
	cursor: pointer;
	font-size: 0.85rem;
	&:hover { background: #f8f9fa; }
`;

export const EmptyState = styled.div`
	text-align: center;
	padding: 60px 20px;
	color: #888;
	font-size: 1.05rem;
`;